import * as z from "zod";

export const FulfillmentOrderIntegrationSourceSchema = z.object({
  integrationId: z.string(),
});
